import { apiClient } from './client';
import { DemoResult } from '@/data/sampleDemoResult';

// Public live-demo endpoints. Anonymous + throttled on the backend; runs the
// real pipeline and deletes the recording once results are returned.

export interface DemoStartResponse {
  id: string;
  status: string;
}

export interface DemoResultResponse {
  status: string; // processing | uploading | draft_ready -> "ready" | error | not_found
  result?: DemoResult;
}

export async function demoStart(blob: Blob): Promise<DemoStartResponse> {
  const formData = new FormData();
  formData.append('file', new File([blob], 'demo.webm', { type: 'audio/webm' }));

  const response = await apiClient.post<DemoStartResponse>('/assessments/demo/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return response.data;
}

export async function demoGetResult(id: string): Promise<DemoResultResponse> {
  const response = await apiClient.get<DemoResultResponse>(`/assessments/demo/${id}/result/`);
  return response.data;
}
